import { useBaseline } from "@/lib/hooks/resume";
import { shortDate } from "@/lib/overview";

/**
 * The resume a member's tailor reads: their saved one, by name and date.
 * Nothing shows until it is read, or for a person with none saved.
 */
export default function SavedResume() {
    const saved = useBaseline().data;
    if (!saved) return null;
    return (
        <div
            data-testid="saved-resume"
            className="flex items-center gap-3 rounded-control border border-line bg-card-raised px-3 py-2.5"
        >
            <span
                aria-hidden="true"
                className="grid size-9 shrink-0 place-items-center rounded-[9px] border border-line bg-card font-mono text-[10px] font-bold text-fg-muted"
            >
                PDF
            </span>
            <span className="flex min-w-0 flex-col text-ui">
                <span className="truncate font-semibold text-fg">{saved.resume.name} resume</span>
                <span className="text-fg-muted">
                    Your saved resume. Updated {shortDate(saved.saved_at)}.
                </span>
            </span>
        </div>
    );
}
